export default __webpack_public_path__ + "static/css3-d940eb0aceef411dcb7d8195b0492cfd.png";